import { ExportSearchGrouping } from '@aibees/elephant/hooks';
import { useBootstrapApi } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-api';
import { useBrowseSearchExports } from '@aibees/elephant/hooks/use-browse-search-exports';
import { ElephantPresetType } from '@aibees/elephant/types';
import { LabelType } from '@aibees/elephant/types/label';
import { useBrowsePresetApi } from '@aibees/shared/api';
import { useMemo } from 'react';

export function useRecordCounts() {
  const { data } = useBootstrapApi();
  const { data: exportData } = useBrowseSearchExports({
    grouping: ExportSearchGrouping.ALL,
  });
  const { data: savedData } = useBrowsePresetApi({
    type: `${ElephantPresetType.COMPANY_SAVED_SEARCH},${ElephantPresetType.PEOPLE_SAVED_SEARCH}`,
  });

  const labelsCount = data?.labels.filter(
    (i) => i.type === LabelType.LABEL
  ).length;
  const listsCount = data?.labels.filter(
    (i) => i.type === LabelType.LIST
  ).length;
  const exportsCount = exportData?.content?.length;
  const savedCount = savedData?.content.length;

  return useMemo(
    () => ({ labelsCount, listsCount, exportsCount, savedCount }),
    [labelsCount, listsCount, exportsCount, savedCount]
  );
}
